import { HAS } from 'shared/api/query/constants';
import { goal as goalConfig } from 'shared/api/query/configs.json';

export default function usePublishedAtFilter() {
  return { publishedAtFilter: { [goalConfig.model]: { filter: { func: { name: HAS, attr: goalConfig.edges.publishedAt } } } } };
}
